import { QRCodeCanvas } from 'qrcode.react';
import { LevelQrCodeCanvasProps } from './level-qr-code-canvas.types';

export const LevelQrCodeCanvas = ({
  canvasRef,
  targetUrl,
  isHidden = true,
}: LevelQrCodeCanvasProps) => {
  return (
    <div
      ref={canvasRef}
      data-testid="level-qr-code-canvas"
      style={{ display: isHidden ? 'none' : 'block' }}
    >
      <QRCodeCanvas value={targetUrl} size={300} level="H" />
    </div>
  );
};
